// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#project-data-table table tbody tr td {\n  padding-top: 12px !important;\n  padding-bottom: 4px !important;\n}", ""]);
// Exports
module.exports = exports;
